import Vue from 'vue'
import Vuex from 'vuex'
import sellConfig from '../config/sell'
import {moduleBuyState} from "./modules/buyState.js";
import {moduleBookshelfScan} from "./modules/bookshelfScan.js";

const memberMutations = {
    setFormItems(state, payload) {
        const name = payload.name;
        const value = payload.value;
        state.formItems[name] = value;
    },
    setFormLabels(state, payload) {
        const name = payload.name;
        const value = payload.value;
        state.formLabels[name] = value;
    },
}
const memberActions = {
    updateFormItems(store, formItem) {
        store.commit('setFormItems', formItem);
    },
    updateFormLabels(store, formLabel) {
        store.commit('setFormLabels', formLabel);
    },
}
const memberGetters = {
    getFormItems: (state) => {
        return state.formItems;
    },
    getFormLabels: (state) => {
        return state.formLabels;
    },
}

const buyMutations = {
    setFormItems(state, payload) {
        const name = payload.name;
        const value = payload.value;
        state.formItems[name] = value;
    },
    setFormLabels(state, payload) {
        const name = payload.name;
        const value = payload.value;
        state.formLabels[name] = value;
    },
    setFormItemsList(state, payload) {
        payload.forEach(item => {
            const name = item.name;
            const value = item.value;
            state.formItems[name] = value;
        });
    },
    setIsShippingFree(state, payload) {
        state.isShippingFree = payload;
    },
    setIsShippingFreeAutoApplication(state, payload) {
        state.isShippingFreeAutoApplication = payload;
    },
    setPickupTimeOffset(state, payload) {
        state.formItems.pickupTimeOffset = payload;
    },
    mutateCouponExpirationDate(state, payload) {
        state.couponExpirationDate = payload;
    },
}
const buyActions = {
    updateFormItems(store, formItem) {
        store.commit('setFormItems', formItem);
    },
    updateFormLabels(store, formLabel) {
        store.commit('setFormLabels', formLabel);
    },
    updateFormItemsList(store, formItem) {
        store.commit('setFormItemsList', formItem);
    },
    async isValidatePickupTime(store) {
        const date = store.state.formItems.pickupDate
        const code = store.state.formItems.pickupTimeCode
        const response = await axios.get(`/api/ajax/pickup-time/validate/${date}/${code}`,
            {
                params: {pickup_request_cut_off_time_offset_in_hours: store.state.formItems.pickupTimeOffset}
            }
        ).catch(e => {
            console.error("validatePickupTime Error: " + e)
        })
        return !!(response && response.status === 200);
    },
    async validateCouponCode(store) {
        const email = store.rootState.member.formItems.email;
        if (!store.state.formItems.campaignCode) {
            return [true, null];
        }
        return axios.post('/api/buy/validateCouponCode', {
            "campaign_code": store.state.formItems.campaignCode,
            "site_code": store.state.formItems.site_code,
            "email": email,
        }).then(response => {
            if (!response.data.result) {
                return [false, null, response.data.campaignErrorMessage, false];
            }
            return [true, response.data.campaignName, null, response.data.shippingFree];

        }).catch(e => {
            console.error({e});

            if (400 <= e.response.status && e.response.status <= 499) {
                return [false, null, 'サーバと通信できませんでした。電波状況の良いところで再度お試しください。', false];

            } else if (500 <= e.response.status && e.response.status <= 599) {
                return [false, null, 'サーバと通信できませんでした。しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。', false];
            }
            return [false, null, 'サーバと通信できませんでした。しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。', false];
        });
    },
    async retrieveCouponCode({dispatch, commit, state}) {
        const [validationResult, appliedCoupon, errorMessage, shippingFree] = await dispatch('validateCouponCode');
        if (validationResult !== true) {
            commit('setFormLabels', {name: 'formattedCampaignName', value: ''})
        }
        if (appliedCoupon) {
            commit('setFormLabels', {name: 'formattedCampaignName', value: appliedCoupon});
        }
        if (!state.formItems.campaignCode) {
            commit('setFormLabels', {name: 'isShippingFree', value: false});
        } else {
            commit('setFormLabels', {name: 'isShippingFree', value: shippingFree});
        }
        return {
            status: validationResult,
            errorMsg: errorMessage
        };
    },
    // URLパラメータの値をストアにセットする
    setUrlParameterValues({dispatch, commit}) {
        let complemented = false;
        const urlParams = new URLSearchParams(window.location.search);
        // URLパラメータがない場合は何もしない
        if (!urlParams) {
            return complemented;
        }
        // 入力補完対象のフィールド
        const targetFields = ['firstname', 'lastname', 'firstnameKatakana', 'lastnameKatakana', 'birthdate', 'telephoneNumber1', 'telephoneNumber2', 'telephoneNumber3', 'postcode', 'addressPrefecture', 'addressLocal1', 'addressLocal2', 'companyName', 'email'];
        urlParams.forEach((paramsValue, key) => {
            // 入力補完対象のフィールドのみセットする
            if (targetFields.includes(key) && paramsValue) {
                if (key === 'birthdate') {
                    const birthdate = paramsValue.split('-');
                    commit('setFormLabels', {name: 'birthdateYear', value: birthdate[0]});
                    commit('setFormLabels', {name: 'birthdateMonth', value: birthdate[1]});
                    commit('setFormLabels', {name: 'birthdateDay', value: birthdate[2]});
                } else if (key === 'email') {
                    moduleMember.mutations.setFormItems(moduleMember.state, {name: key, value: paramsValue});
                } else {
                    commit('setFormItems', {name: key, value: paramsValue});
                }
                // 入力補完が1つでもあれば規約同意済みにする
                moduleMember.mutations.setFormItems(moduleMember.state, {
                    name: 'isAgreedWithTermsAndPrivacy',
                    value: Boolean(true)
                });
                complemented = true;
            }
        });
        return complemented;
    },
}
const buyGetters = {
    getFormItems: (state) => {
        return state.formItems;
    },
    getFormLabels: (state) => {
        return state.formLabels;
    },
    getRequireIdentityUploading: (state) => {
        return state.formItems.identitySubmissionMethodCode === 1;
    },
    isAddressSameAsSuggested: (state) => {
        return ((state.formItems.addressLocal1 != null ? state.formItems.addressLocal1 : '') + (state.formItems.addressLocal2 != null ? state.formItems.addressLocal2 : ''))
            === state.formLabels.suggestedAddress;
    },
    getSelectedIdentitySubmissionMethod: (state) => {
        if (!state.formItems.identitySubmissionMethodCode) return null;
        const selected = VueConfig.sell.identitySubmissionMethod.find(item => Number(item.id) === state.formItems.identitySubmissionMethodCode);
        return selected.id === 1 ? '集荷先住所と同じ住所の身分証をアップロードする' : selected.label;
    },
    getShippingCostCalculation: (state) => {
        return state.formItems.numberOfPackages * VueConfig.sell.shippingFeePerPackage;
    },
    getFormattedPickupDate: (state) => {
        return (new Date(state.formItems.pickupDate)).toLocaleDateString('ja-JP', {
            weekday: 'short',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    },
    getPreviewSokufuriApplication: (state) => {
        return state.formItems.sokufuriApplicationCode === 1
            ? VueConfig.sell.sokufuriApplication[0].label
            : VueConfig.sell.sokufuriApplication[1].label;
    },
    getCouponExpirationDate: (state) => {
        return state.couponExpirationDate;
    },
}

Vue.use(Vuex)

const moduleMember = {
    namespaced: true,
    state: {
        formItems: {
            email: null,
            emailSubscriptionCode: false,
            password: null,
            passwordConfirmation: null,
            isAgreedWithTermsAndPrivacy: null,
            isAgreedCreateMainSiteAccount: false,
            nonInvoiceConsent: null
        },
        formLabels: {
            authenticationExpirationDatetimeFormatted: null,
            requestUUID: null,
            isCollaborationDisplay: false,
            isMemberRegisterGrantPoint: null
        },
    },
    mutations: memberMutations,
    actions: memberActions,
    getters: memberGetters,
};

const moduleBuy = {
    namespaced: true,
    state: {
        formItems: {
            firstname: null,
            lastname: null,
            firstnameKatakana: null,
            lastnameKatakana: null,
            birthdate: null,
            telephoneNumber1: null,
            telephoneNumber2: null,
            telephoneNumber3: null,
            jobCode: null,
            jobLabel: null,
            postcode: null,
            addressPrefecture: null,
            addressLocal1: null,
            addressLocal2: null,
            identitySubmissionMethodCode: null,
            sokufuriApplicationCode: null,
            campaignCode: null,
            buybackCode: null,
            selectedCampaignCode: null,
            numberOfPackages: 1,
            pickupDate: null,
            pickupTimeCode: null,
            isAgreedWithIdentitySubmission: null,
            bankAccountNumber: null,
            bankAccountName: null,
            bankCode: null,
            branchCode: null,
            bankType: null,
            yuucyo_kigou: null,
            yuucyo_hansu: null,
            yuucyo_kouza: null,
            kouza_type: null,
            youshi_code: null,
            img_path1: null,
            img_path2: null,
            site_code: null,

            companyName: null,
            supportGroupId: null,
            supportGroupName: null,
            vbOfficeCode: null,
            nonInvoiceConsent: null,
            pickupTimeOffset: sellConfig.pickupRequestCutOffTimeMinusOffsetInHours,
            autoAppliedCouponCode: null,
        },
        // FIXME: もはやラベルではない値を含むので、formParametersなどに名前変更する。
        //  ペイロード(formItems)と非ペイロードを区別できればよく、formLabelsという名前を残す意義は今のところない。
        formLabels: {
            suggestedAddress: null,
            pickupPeriodName: null,
            pickupPackagesBackup: null,
            pickupAddressBackup: null,
            formattedCampaignName: null,
            birthdateYear: null,
            birthdateMonth: null,
            birthdateDay: null,
            selectedCampaignIndex: null,
            selectedCampaignName: null,
            showRemaining: false,
            numberOfRemaining: null,
            bankName: '',
            branchName: '',
            isShippingFree: false,
            isShippingFreeAutoApplication: false,
            immediateTransferApplyAmount: sellConfig.estimatedPriceIncreasedBySokufuriApplication,
            immediateTransferPriceText: '買取金額',
            isRequestParamCoupon: false,
            requestParamCouponCode: null,
            requestParamCouponName: null,
            isRequestParamCouponError: false,
            requestParamSupportGroupId: null,
            campaignName: null,
            appliedCouponCode: null,
            appliedCouponName: null,
        },
        couponExpirationDate: null,
    },
    mutations: buyMutations,
    actions: buyActions,
    getters: buyGetters,
};
export {moduleMember, moduleBuy};
export default new Vuex.Store({
    modules: {
        member: moduleMember,
        buy: moduleBuy,
        buyState: moduleBuyState,
        bookshelfScan: moduleBookshelfScan,
    }
})
